import React, { useState } from 'react';
import './Product.css';
import Pop from '../assets/gross_map.png';
import PdfViewer2 from '../About/PdfViewer2';
import Loader from '../Loader/Loader'; // import the Loader component

const Product = () => {
  const [showPdfViewer1, setShowPdfViewer1] = useState(false);
  const [loading, setLoading] = useState(false); // add state for loading indicator

  function handleReadMoreClick() {
    setLoading(true); // set loading state to true
    setTimeout(() => {
      setShowPdfViewer1(true);
      setLoading(false); // set loading state to false when the PDF viewer is ready
    }, 5000);
  }

  return (
    <div className="image-description">
      <div className="description">
        <h2>2020 Gross County Product (GCP) of ASAL Counties</h2>
        {loading ? (
          <Loader /> // show the loading indicator
        ) : showPdfViewer1 ? (
          <PdfViewer2 onClose={() => setShowPdfViewer1(false)} />
        ) : (
          <>
            <p>In 2020, the economic output of ASAL counties amounted to 4,225,145 million shillings contributing 42.71% to overall GDP. The arid counties ...</p>
            <button className="read-more-button" onClick={handleReadMoreClick}>Read More</button>
          </>
        )}
      </div>
      <img src={Pop} alt='asals' className="image" />
    </div>
  );
};

export default Product;
